import Head from "next/head";

type Props = {
  title: string;
  url: string;
  description?: string;
  image?: string;
  imageAlt?: string;
  type?: string;
  twitterCard?: string;
  twitterLabel1?: string;
  twitterData1?: string;
  twitterLabel2?: string;
  twitterData2?: string;
  additionalPropertyTags?: Array<{ property: string; content: string }>;
  fbAppId?: string;
};

export default function SEO({
  title,
  description,
  url,
  image,
  imageAlt = "Immutable Play",
  type = "website",
  twitterCard = "summary_large_image",
  twitterLabel1,
  twitterData1,
  twitterLabel2,
  twitterData2,
  additionalPropertyTags = [],
  fbAppId,
}: Props) {
  return (
    <Head>
      <title>{title || "Immutable Play"}</title>

      {/* Primary Meta Tags */}
      {description && <meta name="description" content={description} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      {fbAppId && <meta property="fb:app_id" content={fbAppId} />}

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      {twitterLabel1 && <meta name="twitter:label1" content={twitterLabel1} />}
      {twitterData1 && <meta name="twitter:data1" content={twitterData1} />}
      {twitterLabel2 && <meta name="twitter:label2" content={twitterLabel2} />}
      {twitterData2 && <meta name="twitter:data2" content={twitterData2} />}

      {/* Additional property tags */}
      {additionalPropertyTags.map((tag) => (
        <meta
          key={`prop-${tag.property}`}
          property={tag.property}
          content={tag.content}
        />
      ))}
    </Head>
  );
}
